/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./odometer.vue?vue&type=template&id=94ae75a8&"
import script from "./odometer.vue?vue&type=script&lang=js&"
export * from "./odometer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports